import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_PICKUP_DISPATCHER_BY_ACCOUNT_ID = gql`
    query GetAccountPickupDispatcherByAccountId($accountId: Long!) {
        getAccountPickupDispatcherByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
        }
    }
`;

export interface AccountPickupDispatcherType {
    id: number;
    accountId: number;
    warehouseId: number;
}

export interface GetAccountPickupDispatcherByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountPickupDispatcherByAccountIdQuery {
    getAccountPickupDispatcherByAccountId: AccountPickupDispatcherType;
}

export const getAccountPickupDispatcherByAccountId = async (accountId: number): Promise<AccountPickupDispatcherType> => {
    const {data} = await client.query<GetAccountPickupDispatcherByAccountIdQuery, GetAccountPickupDispatcherByAccountIdQueryVariables>({
        query: GET_ACCOUNT_PICKUP_DISPATCHER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountPickupDispatcherByAccountId;
}; 